import React from "react";

const Promotions = () => {
  return <div>Suppliers</div>;
};

export default Promotions;
